import { SALES_DATA } from '../../constants/ActionTypes';

export const salesPersonAction = (sales) => {
  return (dispatch) => {
    dispatch({ type: SALES_DATA, payload: sales });
  };
};
